import { render } from "./PenalidadesManagement.vue?vue&type=template&id=b8c1a0f8&scoped=true"
import script from "./PenalidadesManagement.vue?vue&type=script&lang=js"
export * from "./PenalidadesManagement.vue?vue&type=script&lang=js"

import "./PenalidadesManagement.vue?vue&type=style&index=0&id=b8c1a0f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c1a0f8"]])

export default __exports__